"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolProvider = void 0;
const protocol_1 = require("../../protocol");
const utils_1 = require("../../utils");
const bs58_1 = __importDefault(require("bs58"));
const media_1 = require("../../utils/media");
const InjectUtils_1 = require("../InjectUtils");
class SolProvider {
    constructor() {
        // TOOD
        // 问题: 是否需要切链  不切链, 主网 测试网络  sonic 如何区别
        this.accountChangedSolanaPublicKeyHandler = null;
    }
    send(request) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                yield this.restoreConnect();
                (0, utils_1.logDebug)("SolProvider send request:", JSON.stringify(request));
                const method = request.method;
                let result;
                if (request.injectParams) {
                    switch (method) {
                        case "solana_signMessage":
                            {
                                if (request.injectParams && typeof request.injectParams === 'object' && 'message' in request.injectParams) {
                                    var message = (_a = request.injectParams) === null || _a === void 0 ? void 0 : _a.message;
                                    const encodedMessage = new TextEncoder().encode(message);
                                    const signedMessage = yield window.okxwallet.solana.signMessage(encodedMessage, "utf8");
                                    result = {
                                        method: request.method,
                                        result: bs58_1.default.encode(signedMessage.signature),
                                    };
                                    (0, utils_1.logDebug)("SolProvider send result:", JSON.stringify(signedMessage));
                                    return result;
                                }
                                else {
                                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `param is error method: '${method}'`);
                                }
                            }
                            break;
                        case "solana_signTransaction":
                            {
                                let bufferResult = yield window.okxwallet.solana.signTransaction(request.injectParams);
                                (0, utils_1.logDebug)("SolProvider send bufferResult:", JSON.stringify(bufferResult));
                                result = {
                                    method: request.method,
                                    injectResult: bufferResult,
                                };
                                (0, utils_1.logDebug)("SolProvider send result:", (0, utils_1.safeJsonStringify)(result));
                                return result;
                            }
                            break;
                        case "solana_signAllTransactions":
                            {
                                let allResult = yield window.okxwallet.solana.signAllTransactions(request.injectParams);
                                (0, utils_1.logDebug)("SolProvider send result:", (0, utils_1.safeJsonStringify)(allResult));
                                result = {
                                    method: request.method,
                                    injectResult: allResult,
                                };
                                return result;
                            }
                            break;
                        case "solana_signAndSendTransaction":
                            {
                                var signAndSendResult = yield window.okxwallet.solana.signAndSendTransaction(request.injectParams);
                                (0, utils_1.logDebug)("SolProvider send result:", (0, utils_1.safeJsonStringify)(signAndSendResult));
                                result = {
                                    method: request.method,
                                    injectResult: signAndSendResult,
                                };
                                return result;
                            }
                            break;
                        default:
                            throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED, `method: '${method}'`);
                    }
                }
                else {
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `param is error method: '${method}'`);
                }
            }
            catch (error) {
                (0, utils_1.logDebug)("SolProvider send error:", error);
                throw error;
            }
        });
    }
    disconnect() {
    }
    restoreConnect() {
        if ((0, media_1.isDevice)("mobile")) {
            return this.connect();
        }
        return Promise.resolve();
    }
    parseConnectResponse(needPop, accountChange, signalChain, connectWalletNameSpace, connectRequestWalletResponse, dappInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            let connectChain = [];
            connectWalletNameSpace.forEach(item => {
                if (item.namespace === protocol_1.NameSpaceKeySOL) {
                    connectChain.push(...item.chains);
                }
            });
            let addresses = [];
            let extra = {};
            let accounts = {};
            // if (!isDevice("mobile")){
            //      accounts = await window.okxwallet.solana.connect()
            //     logDebug("parseConnectResponse solana.connect() :",JSON.stringify(accounts))
            // }
            connectChain.forEach((chainStr) => {
                let selectedAddress = connectRequestWalletResponse.address.find((addressItem) => {
                    return (addressItem.chainId === "501" && addressItem.coinType === 501)
                        || (addressItem.namespaceChainId === chainStr);
                });
                if (selectedAddress) {
                    addresses.push(chainStr + ":" + selectedAddress.address);
                    if (accounts && "publicKey" in accounts) {
                        extra[chainStr] = accounts;
                    }
                    else {
                        extra[chainStr] = {
                            publicKey: selectedAddress.publicKey
                        };
                    }
                }
            });
            if (addresses && addresses.length > 0) {
                let nameSpaceResponse = {
                    namespace: protocol_1.NameSpaceKeySOL,
                    addresses: addresses,
                    methods: [...InjectUtils_1.SOLANAMethods],
                    extra: extra
                };
                (0, utils_1.logDebug)("parseConnectResponse nameSpaceResponse :", JSON.stringify(nameSpaceResponse));
                return nameSpaceResponse;
            }
            return undefined;
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            return window.okxwallet.solana.connect();
        });
    }
    singleConnect() {
        return this.connect();
    }
    addAccountChangedListener(accountChangeListener) {
        console.log("window.okxwallet configEventWithKey:", 'sol');
        this.accountChangedSolanaPublicKeyHandler = (publicKey) => {
            console.log("window.okxwallet configEventWithKey_solana:", Date.now(), 'sol', publicKey);
            if (publicKey) {
                accountChangeListener();
            }
        };
        window.okxwallet.solana.on('accountChanged', this.accountChangedSolanaPublicKeyHandler);
    }
    removeListener() {
        if (this.accountChangedSolanaPublicKeyHandler) {
            window.okxwallet.solana.removeListener('accountChanged', this.accountChangedSolanaPublicKeyHandler);
        }
    }
}
exports.SolProvider = SolProvider;
